import React from 'react'
import AddExtraItems from '../../../components/store/products/form/ExtraItemsForm'
import MainTitle from '../../../components/ui/MainTitle'

export default function AddProductExtraItems() {
  return (
    <div className=' container p-6 h-[100vh] overflow-auto'>
        <div className="mb-14">
            <MainTitle title="add_new_product"/>
        </div>
        <div>
            <AddExtraItems/>
        </div>
    </div>
  )
}
